import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import StatusModal from '../components/StatusModal' ; // Adjust path if needed

const RequestOtp = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    type: '',
    message: '',
  });

  const navigate = useNavigate();

  const handleRequestOtp = async () => {
    setLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/request-otp`,
        { email }
      );

      // Show success modal
      setModal({
        show: true,
        type: 'success',
        message: res.data.message || 'OTP sent successfully!',
      });

      // Navigate after 2s
      setTimeout(() => {
        setModal({ ...modal, show: false });
        navigate('/reset-password');
      }, 2000);
    } catch (err) {
      // Show error modal
      setModal({
        show: true,
        type: 'error',
        message: err.response?.data?.message || 'Failed to send OTP.',
      });
    } finally {
      setLoading(false);
      setEmail('');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900 text-white px-4">
      <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-8 shadow-lg w-full max-w-md relative">
        <h2 className="text-2xl font-bold mb-6 text-center">Forgot Password</h2>
        <input
          type="email"
          placeholder="Enter your registered email"
          className="w-full px-4 py-2 mb-4 rounded-lg bg-white bg-opacity-20 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-400"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
        />
        <button
          onClick={handleRequestOtp}
          disabled={loading}
          className={`w-full py-2 rounded-lg transition font-semibold ${
            loading ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
          }`}
        >
          {loading ? 'Sending OTP...' : 'Send OTP'}
        </button>

        {/* Spinner Overlay */}
        {loading && (
          <div className="absolute inset-0 bg-black bg-opacity-30 flex justify-center items-center rounded-xl z-10">
            <div className="animate-spin w-8 h-8 border-4 border-white border-t-transparent rounded-full"></div>
          </div>
        )}
      </div>

      {/* Status Modal */}
      <StatusModal
        show={modal.show}
        onClose={() => setModal({ ...modal, show: false })}
        type={modal.type}
        message={modal.message}
      />
    </div>
  );
};

export default RequestOtp;
